import axiosInstance from "../../api/axios";

const ProcessingReportService = {
    getAllReports: async () => {
        const response = await axiosInstance.get("/v1/reports");
        return response.data;
    },

    getReportById: async (id, params = {}) => {
        // Convert params object to URL query parameters
        const queryParams = new URLSearchParams();

        // Add pagination parameters if provided
        if (params.title_page) queryParams.append('title_page', params.title_page);
        if (params.title_per_page) queryParams.append('title_per_page', params.title_per_page);
        if (params.dsp_page) queryParams.append('dsp_page', params.dsp_page);
        if (params.dsp_per_page) queryParams.append('dsp_per_page', params.dsp_per_page);
        if (params.country_page) queryParams.append('country_page', params.country_page);
        if (params.country_per_page) queryParams.append('country_per_page', params.country_per_page);
        if (params.typesale_page) queryParams.append('typesale_page', params.typesale_page);
        if (params.typesale_per_page) queryParams.append('typesale_per_page', params.typesale_per_page);
        if (params.refresh) queryParams.append('refresh', '1');

        // Build the URL with query parameters
        const url = `/v1/reports/${id}${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
        console.log('Fetching report with URL:', url);

        try {
            const response = await axiosInstance.get(url);
            console.log('Report data received:', response.data);
            return response.data;
        } catch (error) {
            console.error('Error fetching report:', error);
            throw error;
        }
    },

    // New methods for fetching individual distribution types using the dedicated endpoint
    getTitleDistribution: async (incomeId, page = 1, perPage = 10) => {
        const queryParams = new URLSearchParams({
            distribution_type: 'title_distribution',
            title_page: page,
            title_per_page: perPage
        });

        // Use the dedicated distributions endpoint
        const url = `/v1/reports/${incomeId}/distributions?${queryParams.toString()}`;
        console.log('Fetching title distribution with URL:', url);

        const response = await axiosInstance.get(url);
        return response.data;
    },

    getDspDistribution: async (incomeId, page = 1, perPage = 10) => {
        const queryParams = new URLSearchParams({
            distribution_type: 'dsp_distribution',
            dsp_page: page,
            dsp_per_page: perPage
        });

        // Use the dedicated distributions endpoint
        const url = `/v1/reports/${incomeId}/distributions?${queryParams.toString()}`;
        console.log('Fetching DSP distribution with URL:', url);

        const response = await axiosInstance.get(url);
        return response.data;
    },

    getCountryDistribution: async (incomeId, page = 1, perPage = 10) => {
        const queryParams = new URLSearchParams({
            distribution_type: 'country_distribution',
            country_page: page,
            country_per_page: perPage
        });

        // Use the dedicated distributions endpoint
        const url = `/v1/reports/${incomeId}/distributions?${queryParams.toString()}`;
        console.log('Fetching country distribution with URL:', url);

        const response = await axiosInstance.get(url);
        return response.data;
    },

    getTypesaleDistribution: async (incomeId, page = 1, perPage = 10) => {
        const queryParams = new URLSearchParams({
            distribution_type: 'typesale_distribution',
            typesale_page: page,
            typesale_per_page: perPage
        });

        // Use the dedicated distributions endpoint
        const url = `/v1/reports/${incomeId}/distributions?${queryParams.toString()}`;
        console.log('Fetching typesale distribution with URL:', url);

        const response = await axiosInstance.get(url);
        return response.data;
    },

    downloadReportFile: async (id) => {
        const response = await axiosInstance.get(`/v1/reports/${id}/download`, {
            responseType: 'blob',
        });
        const contentDisposition = response.headers['content-disposition'];
        const fileName = contentDisposition ? contentDisposition.split('filename=')[1].replace(/"/g, '') : 'report_file.csv';
        const mimeType = response.headers['content-type'];
        return { data: response.data, fileName, mimeType };
    },

    updateDistribution: async (data) => {
        const response = await axiosInstance.post('/v1/distributions/update', data);
        return response.data;
    },

    getArtists: async () => {
        const response = await axiosInstance.get('/artists');
        return response.data; // The response has { success: true, artists: [...] } structure
    },

    /**
     * Get AFR (Artist For Review) distribution counts per type for a given income/report ID.
     * Returns { success, data: { title, dsp, country, typesale, income_id } }
     */
    getAfrCounts: async (id) => {
        const response = await axiosInstance.get(`/v1/reports/${id}/afr-counts`);
        return response.data;
    },

    getAfrTitleDistribution(incomeId, page = 1, perPage = 10) {
        return this.getTitleDistribution(incomeId, page, perPage);
    },

    getAfrDspDistribution(incomeId, page = 1, perPage = 10) {
        return this.getDspDistribution(incomeId, page, perPage);
    },

    getAfrCountryDistribution(incomeId, page = 1, perPage = 10) {
        return this.getCountryDistribution(incomeId, page, perPage);
    },

    getAfrTypesaleDistribution(incomeId, page = 1, perPage = 10) {
        return this.getTypesaleDistribution(incomeId, page, perPage);
    },
};

export default ProcessingReportService;
